<template>
	<div ref="authEdit" class="dialog-container">
		<div class="dialog" style="max-height: 600px; transform: translate(0, -300px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Auth Edit
					</p>
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="17%" />
							<col width="33%" />
							<col width="17%" />
							<col width="33%" />
						</colgroup>
						<tbody>
							<tr>
								<th>
									Auth Code.
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="authCode"
										v-model="item.authCode"
										v-validate="'required'"
										data-vv-as="Auth Code"
									/>
									<p class="txt-validation" v-if="errors.has('authCode')">
										* {{ errors.first("authCode") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>
									Auth Name.
								</th>
								<td colspan="3">
									<input
										type="text"
										class="input-crud"
										name="authName"
										v-model="item.authName"
										v-validate="'required'"
										data-vv-as="Auth Name"
									/>
									<p class="txt-validation" v-if="errors.has('authName')">
										* {{ errors.first("authName") }}
									</p>
								</td>
							</tr>
							<tr>
								<th>Register.</th>
								<td>
									{{ item.authRegistUserId }}
								</td>
								<th>
									Regist Date.
								</th>
								<td>
									{{ item.authRegistDt }}
								</td>
							</tr>
							<tr>
								<th>Etc.</th>
								<td colspan="3">
									<textarea
										class="textarea-crud"
										name="authEtc"
										v-model="item.authEtc"
									></textarea>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Modify" @click.stop="doValidation()">
						Modify
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
	name: "AuthEdit",
	created() {
		this.logger.debug(this, "created()");
		this.doSelect();
	},
	props: {
		authNo: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: {}
		};
	},
	methods: {
		doSelect() {
			this.logger.debug(this, "doSelect()");
			axios
				.post(this.config.contextRoot + "/auth/select.do", {authNo: this.authNo})
				.then((response) => {
					console.log(response);
					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to modify the current auth?", "Question", "question").then(() => {
							EventBus.$emit("setting-loading", true);
							this.doUpdate();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doUpdate() {
			this.logger.debug(this, "doUpdate()");
			axios
				.post(this.config.contextRoot + "/auth/update.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						location.reload();
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the auth modification?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.authEdit.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.authEdit.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("setting-cancel", "isAuthEdit");
			}.bind(this), 410);
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
</style>